import refs from "../refs"
import {showBackdrop, hideBackdrop} from "../utils"

const {feedbackButtons, feedbackBackdrop, menuBackdrop, feedbackCloseButton, popup_feedback} = refs;

const handleClick = () => {
    const mobileMenuBackdrop = document.querySelector("[data-mobile-menu-backdrop]");
    if (mobileMenuBackdrop && mobileMenuBackdrop.classList.contains("is-visible")) {
        const closeBtn = mobileMenuBackdrop.querySelector("[data-mobile-menu-close]");
        if (closeBtn) {
            closeBtn.click();
        } else {
            mobileMenuBackdrop.classList.remove("is-visible");
        }
    }

    if (!menuBackdrop.hasClass("is-hidden")) {
        hideBackdrop(menuBackdrop);
    }
    showBackdrop(feedbackBackdrop);
};

feedbackButtons.on('click', handleClick)
feedbackCloseButton.on("click", () => hideBackdrop(feedbackBackdrop))


popup_feedback?.querySelector('input[type="checkbox"]')?.addEventListener('change', function(){
	if(this.checked){
			popup_feedback.querySelector('button[type="submit"]')?.removeAttribute('disabled')
	}else{
			popup_feedback.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled')
	}
})